import { Autocomplete, AutocompleteCloseReason } from "@material-ui/lab";
import { ChevronDown } from "react-feather";
import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  autocomplete: {
    marginTop: theme.spacing(2),
  },
  autocompleteInput: {
    "& .MuiAutocomplete-input": {
      minWidth: "76px",
      textAlign: "right",
    },
    "& .MuiInputAdornment-positionEnd": {
      marginLeft: "auto",
    },
    "& .MuiOutlinedInput-root": {
      paddingTop: "18px",
    },
  },
}));

interface TagSelectionMultiSelectProps {
  values: string[];
  tagOptions: string[];
  onTagChange: (newValues: string[]) => void;
  label: string;
  maxSelection?: number;
  disabled?: boolean;
}

const TagSelectionMultiSelect: React.FC<TagSelectionMultiSelectProps> = ({
  values,
  tagOptions,
  onTagChange,
  label,
  maxSelection,
  disabled,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClose = (event: unknown, reason: AutocompleteCloseReason) => {
    if (reason !== "select-option") {
      setOpen(false);
    }
  };

  return (
    <Autocomplete
      className={classes.autocomplete}
      disableClearable
      forcePopupIcon={false}
      multiple
      onChange={(_event, newValues) => {
        onTagChange(newValues);
      }}
      options={tagOptions}
      open={tagOptions.length > 0 && open}
      onOpen={() => setOpen(true)}
      onClose={handleClose}
      getOptionLabel={option => option}
      getOptionSelected={(option, value) => option === value}
      getOptionDisabled={() => values.length >= (maxSelection || Infinity)}
      ChipProps={{
        ["data-test"]: "tag-chip",
      }}
      disabled={disabled}
      renderInput={params => (
        <TextField
          {...params}
          className={classes.autocompleteInput}
          label={label}
          variant="outlined"
          placeholder="Select"
          disabled={disabled}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <ChevronDown />
              </InputAdornment>
            ),
          }}
        />
      )}
      value={values}
    />
  );
};

export default TagSelectionMultiSelect;
